import React, { ReactNode, createContext, Dispatch, SetStateAction } from "react";
import useAuth, { FormPassword, UserProps, UserToken } from "./hooks/useAuth";

interface AuthContextProviderProps {
  children: ReactNode;
}

const initialState: AuthContextData = {
  user: { password: "", email: "" },
  setUser: () => {},
  authenticated: false,
  handleLogin: () => {},
  handleLogout: () => {},
  loadingButton: false,
  objUserTk: { Email: "", AgentId: 0 },
  formPassword: { password: "", confirmPassword: "" },
  setFormPassword: () => {},
  // handleChangePassword: async () => {},
  updateUserPassword: async () => {},
  sendResetPasswordEmail: async () => {},
  verifyResetCode: async () => false,
};

export interface AuthContextData {
  user: { password: string; email: string };
  setUser: (user: UserProps) => void;
  authenticated: boolean;
  handleLogin: (user: UserProps) => void;
  handleLogout: () => void;
  loadingButton: boolean;
  objUserTk: UserToken;
  formPassword: FormPassword;
  setFormPassword: (data: FormPassword) => void;
  // handleChangePassword: (data: FormPassword) => Promise<void>;
  updateUserPassword: (userId: number, newPassword: string) => Promise<void>;
  sendResetPasswordEmail: (email: string) => Promise<void>;
  verifyResetCode: (email: string, code: string) => Promise<boolean>;
}

export const AuthContext = createContext<AuthContextData>(initialState);

export default function AuthContextProvider({ children }: AuthContextProviderProps) {
  const {
    data,
    authenticated,
    loadingButton,
    handleLogin,
    handleLogout,
    handleSetUser,
    objUserTk,
    formPassword,
    setFormPassword,
    // handleChangePassword,
    updateUserPassword,
    sendResetPasswordEmail,
    verifyResetCode,
  } = useAuth();

  return (
    <AuthContext.Provider
      value={{
        user: data,
        setUser: handleSetUser,
        authenticated,
        handleLogin,
        handleLogout,
        loadingButton,
        objUserTk: objUserTk,
        formPassword,
        setFormPassword,
        // handleChangePassword,
        updateUserPassword,
        sendResetPasswordEmail,
        verifyResetCode,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
